import { render, staticRenderFns } from "./BusinessPremises.vue?vue&type=template&id=44ac5970&scoped=true&"
import script from "./BusinessPremises.vue?vue&type=script&lang=js&"
export * from "./BusinessPremises.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPremises.vue?vue&type=style&index=0&id=44ac5970&prod&lang=less&scoped=true&"
import style1 from "./BusinessPremises.vue?vue&type=style&index=1&id=44ac5970&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac5970",
  null
  
)

export default component.exports